import { injectIntl } from "react-intl";

const IntlHOC = (WrappedComponent) => {
    return injectIntl(WrappedComponent, {
        withRef: false
    });
}

export default IntlHOC;